import { VAT_EXEMPT_ELIGIBLE_COUNTRIES } from '../constants';

export const getIsTaxExempt = (taxExempt: string) => taxExempt === 'exempt';

/**
 * util that checks if the usrs current billing country
 * exist in the list of vat exempt elligible countries.
 */
export const getIsBillingCountryVatExemptEligible = (
  billingCountryAbbreviation: string
) =>
  VAT_EXEMPT_ELIGIBLE_COUNTRIES.some(
    (country) => country.code === billingCountryAbbreviation
  );

/**
 * util used to map a countries abbreviation to
 * their countries unabbreviated name
 */
export const getCountryNameFromAbbreviation = (
  billingCountryAbbreviation: string
) =>
  VAT_EXEMPT_ELIGIBLE_COUNTRIES.find(
    (element) => element.code === billingCountryAbbreviation
  )?.country;
